/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Card, Stack, Tab, Typography } from '@mui/material';
import ScrollableTabs from 'components/shared/ScrollableTabs';
import CheckboxInput from 'components/input/CheckboxInput';
import CustomTabPanel from './TabPanel';
import LoadingContent from 'components/LoadingContent';
import {
  checkEnableParseJSON,
  paserSubjectFirst,
  checkEmptyValue,
  checkSubjectMap,
  checkNoCreditAwarded,
  checkNoCreditEligible,
  getPointYearFromSchedule,
  checkNoCreditGradeCollege,
  getKeyTypeOfCourse,
  checkWeightedCourse,
  tryParseJSON,
  checkTypeOfClass,
  isSemesterOn,
  checkThreeTrimester,
  checkTypeOfClassDualEnrollment,
  formatBoolean,
  formatBooleanToYesNo,
} from 'components/helper/helper';
import { useParams } from 'react-router-dom';
import courseServices from 'services/courseServices';
import CourseGrade9Summary from 'screen/summary/components/CourseGrade9Summary';
import CourseGrade12Summary from 'screen/summary/components/CourseGrade12Summary';
import CourseCollegeSum from 'screen/summary/components/CourseCollegeSum';
import SimpleTable from 'components/table/SimpleTable';
import { useAppSelector } from 'app/hooks';
import { buildClassName, agSubjectTotals, wCourseSummary, buildPageStatusClassName } from './RPersonalInformation';
// import { ModalCheckGradeField } from 'screen/common/ModalCheckGradeField';
import { PAGE_NAME, USER_ROLE } from 'constants/common';
// import { ModalCheckGeneralGradeField } from 'screen/common/ModalCheckGeneralGradeField';
// import { ModalCheckCollgeCourseField } from 'screen/common/ModalCheckCollgeCourseField';
import { mapAGSumaryCalculation, mapAGSumary_Value } from 'screen/common/helper/fixValuesOnLoad';
import { isPercentNumericScale } from 'screen/course/courseConstant';
import { GeneralSemesterOption } from './CoursesAndGrades/CoursesAndGradesOptions';
import GPAForecasterSummary from './CoursesAndGrades/GPAForecasterSummary';
import { toggleCounselorReviewedAndComplete } from 'services/reviewAndComplete';
import pageStatusService from 'services/pageStatusService';
import { usePageStatus } from 'hooks/usePageStatus';
import { getUserRole } from 'utils/sessionStorage';

const RCoursesAndGrades = ({
  setCurrentModuleId,
  isCounselor,
}: {
  setCurrentModuleId: (id: string) => void;
  isCounselor?: boolean;
}) => {
  const checkModule = useAppSelector((store) => store.basicInformation.checkModule);
  const [value, setValue] = React.useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const params: { id?: string | number } = useParams();
  const { pageStatus } = usePageStatus({ studentId: params.id || '' });

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`5.${newValue}`);
  };

  return (
    <div>
      <ScrollableTabs
        className="mt-2"
        value={value}
        onChange={handleChange}
        variant="scrollable"
        sx={{
          position: 'sticky',
          top: isCounselor ? '72px' : '0',
          left: 0,
          right: 0,
          zIndex: 11,
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'divider',
          paddingTop: '8px',
          paddingBottom: '8px',
          marginTop: 0,
          width: '100%',
          willChange: 'transform',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
        }}
      >
        <Tab value={1} label="General" 
        // className={buildClassName('5.1', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.GENERAL_COURSE)}
        />
        <Tab value={2} label="9th" 
        // className={buildClassName('5.2', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.GRADE_9)}
        />
        <Tab value={3} label="10th" 
        // className={buildClassName('5.3', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.GRADE_10)}
        />
        <Tab value={4} label="11th" 
        // className={buildClassName('5.4', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.GRADE_11)}
        />
        <Tab value={5} label="12th" 
        // className={buildClassName('5.5', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.GRADE_12)}
        />
        <Tab value={6} label="College Courses" 
        // className={buildClassName('5.6', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.COLLEGE_COURSE)}
        />
        <Tab value={7} label="A-G Summary" className={buildClassName('5.7', checkModule)} />
        <Tab value={8} label="(W) Course Summary" className={buildClassName('5.8', checkModule)} />
        <Tab value={9} label="GPA Forecaster" className={buildClassName('5.9', checkModule)} />
      </ScrollableTabs>
      <CustomTabPanel value={value} index={1}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryGeneral isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <Summary9th isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <Summary10th isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <Summary11th isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <Summary12th isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryCollegeCourses isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={7}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
            A-G Summary
          </Typography>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <AGSummary />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={8}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
            (W) Course Summary
          </Typography>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <WCourseSummary />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={9}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
            GPA Forecaster
          </Typography>
          <Stack justifyContent={'center'} alignItems={'center'} className="main-statistic">
            <GPAForecasterSummary />
          </Stack>
        </Card>
      </CustomTabPanel>
    </div>
  );
};

export default RCoursesAndGrades;

const SummaryGeneral = ({ isMobile }: { isMobile: boolean }) => {
  const [myGeneralInfo, setMyGeneralInfo] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.GENERAL_COURSE, reviewedAndComplete, setReviewedAndComplete);
  };
  const [show, setShow] = React.useState(false); // show model checkfield
  const handleCloseModalCheck = () => {
    setShow(false);
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await courseServices.getGeneral(params.id);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.GENERAL_COURSE
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setMyGeneralInfo({ ...res, additional_info: checkEnableParseJSON(res.additional_info, {}) });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const countGrades = (course: any) => {
    switch (course?.schedule) {
      case 'Semester':
        return 2;
      case 'Trimester':
        return 3;
      case 'Quarter':
      case 'Quarters':
        return 4;
      default:
        return 0;
    }
  };

  //console.log('myGeneralInfo:', myGeneralInfo);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          General
        </Typography>
        <div>
        </div>
      </div>
      {myGeneralInfo && (
        <>
          {/* Transcript Information Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Transcript Information</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  I am able to obtain a copy of my transcript(s)
                </div>
                <div className="gm-summary-field-value">
                  {myGeneralInfo.is_able_obtain_copy_transcript ? 'Yes' : 'No'}
                </div>
              </div>
            </div>

            {!myGeneralInfo.is_able_obtain_copy_transcript && (
              <div className="gm-summary-field-grid pt-2">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Based on your responses, you are not required to complete this section. Colleges
                    who are listed above as requiring this information will not penalize you. Please
                    have your counselor submit your transcripts as per their usual methods
                  </div>
                  <div className="gm-summary-field-input">
                    {/* {myGeneralInfo.is_counselor_submit_transcript ? 'Yes' : 'No'} */}
                    <CheckboxInput
                      logo="check-label"
                      className="mb-3 check-blue"
                      disabled={true}
                      name={'is_counselor_submit_transcript'}
                      label="I understand"
                      values={myGeneralInfo.is_counselor_submit_transcript}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  My transcript shows grades for courses I've completed
                </div>
                <div className="gm-summary-field-value">
                  {myGeneralInfo.is_transcript_show_grade_completed ? 'Yes' : 'No'}
                </div>
              </div>
            </div>

            {!myGeneralInfo.is_transcript_show_grade_completed && (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">
                    Based on your responses, you are not required to complete this section. Colleges
                    who are listed above as requiring this information will not penalize you. Please
                    have your counselor submit your transcripts as per their usual methods
                  </div>
                  <div className="gm-summary-field-value">
                    {myGeneralInfo.is_counselor_submit_transcript_2 ? 'Yes' : 'No'}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Middle School Academic History Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Middle School - Academic History</div>
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              Mathematics or foreign language courses are common middle courses that count toward
              your high school requirements.
            </div>
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              If any of your middle school courses are listed on your transcript, be sure to list
              them here, too.
            </div>
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              Note: On the college applications, you do not need to list the courses under your
              middle school name, they will be listed under your high school
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Did you take any course(s) in middle school that fulfilled your high school
                  subject requirements?
                  <span className="gm-summary-field-logo span-uc-logo"></span>
                  <span className="gm-summary-field-logo span-csu-logo"></span>
                </div>
                <div className="gm-summary-field-value">
                  {formatBoolean(myGeneralInfo?.additional_info?.is_take_course_in_middle_school)
                    ? 'Yes'
                    : 'No'}
                </div>
              </div>
            </div>

            {formatBoolean(myGeneralInfo?.additional_info?.is_take_course_in_middle_school) ===
              true && (
              <>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Do you have middle school courses listed on your transcript that have been
                      issued official transcript grades?*
                      <span className="gm-summary-field-logo span-cm-logo"></span>
                    </div>
                    <div className="gm-summary-field-value">
                      {formatBoolean(
                        myGeneralInfo?.additional_info
                          ?.is_have_course_issued_official_transcript_grades
                      )
                        ? 'Yes'
                        : 'No'}
                    </div>
                  </div>
                </div>

                {/* Middle School Coursework Section */}
                {(myGeneralInfo?.additional_info?.course_work ?? []).length > 0 && (
                  <div className="gm-summary-section2 pt-5">
                    <div className="gm-summary-subsection-title">Middle School Coursework</div>
                    {(myGeneralInfo?.additional_info?.course_work ?? []).map(
                      (course: any, index: number) => (
                        <>
                          <div key={`course_${index}}`} className="gm-summary-conditional-section">
                            <div className="gm-summary-field-grid">
                              <div className="gm-summary-field-item">
                                <div className="gm-summary-field-label">
                                  Select the school for this coursework
                                </div>
                                <div className="gm-summary-field-value">{course.school || '-'}</div>
                              </div>

                              <div className="row w-100">
                                <div className="col-md-6 pe-md-2">
                                  <div className="gm-summary-field-label">Grade Level*</div>
                                  <div className="gm-summary-field-value">
                                    {course?.grade_level || '-'}
                                  </div>
                                </div>
                                <div className="col-md-6 ps-md-2">
                                  <div className="gm-summary-field-label">School Year*</div>
                                  <div className="gm-summary-field-value">
                                    {course?.school_year || '-'}
                                  </div>
                                </div>
                              </div>

                              <div className="row w-100">
                                <div className="col-md-6 pe-md-2">
                                  <div className="gm-summary-field-label">Grading Scale</div>
                                  <div className="gm-summary-field-value">
                                    {course?.grade_scale || '-'}
                                  </div>
                                </div>
                                <div className="col-md-6 ps-md-2">
                                  <div className="gm-summary-field-label">Term period*</div>
                                  <div className="gm-summary-field-value">
                                    {course?.term_period || '-'}
                                  </div>
                                </div>
                              </div>

                              <div className="row w-100">
                                <div className="col-md-6 pe-md-2">
                                  <div className="gm-summary-field-label">Schedule*</div>
                                  <div className="gm-summary-field-value">
                                    {course?.schedule || '-'}
                                  </div>
                                </div>

                                {course?.schedule === 'Other' && (
                                  <div className="col-md-6 ps-md-2">
                                    <div className="gm-summary-field-label">
                                      Please describe schedule*
                                    </div>
                                    <div className="gm-summary-field-value">
                                      {course?.describe_other_schedule}
                                    </div>
                                  </div>
                                )}

                                <div
                                  className={`col-md-6 ${
                                    course?.schedule === 'Other' ? 'pe-md-2' : 'ps-md-2'
                                  }`}
                                >
                                  <div className="gm-summary-field-label">
                                    A-G Subject Requirement
                                    <span
                                      className="span-uc-logo"
                                      style={{ marginRight: '10px', marginLeft: '10px' }}
                                    ></span>
                                    <span
                                      className="span-csu-logo"
                                      style={{ marginRight: '10px', marginLeft: '10px' }}
                                    ></span>
                                  </div>
                                  <div className="gm-summary-field-value">
                                    {course?.ag_subject_requirement || '-'}
                                  </div>
                                </div>
                              </div>

                              {course?.ag_subject_requirement ===
                                'E Language Other than English' && (
                                <div className="row w-100">
                                  <div className="col-md-6 pe-md-2">
                                    <div className="gm-summary-field-label">Language Name</div>
                                    <div className="gm-summary-field-value">
                                      {course?.language_name_for_UC || '-'}
                                    </div>
                                  </div>
                                  <div className="col-md-6 ps-md-2">
                                    <div className="gm-summary-field-label">Course category *</div>
                                    <div className="gm-summary-field-value">
                                      {course?.course_category || '-'}
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="row w-100">
                                <div className="col-md-12">
                                  <div className="gm-summary-field-label">Subject/Discipline</div>
                                  <div className="gm-summary-field-value">
                                    {course?.subject_discipline || '-'}
                                  </div>
                                </div>
                              </div>

                              <div className="row w-100">
                                {course?.ag_subject_requirement === 'C Mathematics' && (
                                  <div className="col-md-12">
                                    <div className="gm-summary-field-label">
                                      Course name *
                                      <span
                                        className="span-uc-logo"
                                        style={{ marginRight: '10px', marginLeft: '10px' }}
                                      ></span>
                                    </div>
                                    <div className="gm-summary-field-value">
                                      {course?.course_name_for_UC || '-'}
                                    </div>
                                  </div>
                                )}

                                <div className="col-md-12">
                                  <div className="gm-summary-field-label">
                                    Course Name
                                    <span
                                      className="span-cm-logo"
                                      style={{ marginRight: '10px' }}
                                    ></span>
                                  </div>
                                  <div className="gm-summary-field-value">
                                    {course?.course_name || '-'}
                                  </div>
                                </div>
                              </div>

                              <div className="row w-100">
                                <div className="col-md-6 pe-md-2">
                                  <div className="gm-summary-field-label">Type of Class</div>
                                  <div className="gm-summary-field-value">
                                    {course?.type_of_class || '-'}
                                  </div>
                                </div>
                                <div className="col-md-6 ps-md-2">
                                  <div className="gm-summary-field-label">
                                    Is this a weighted course?
                                  </div>
                                  <div className="gm-summary-field-value">
                                    {formatBooleanToYesNo(course?.is_weighted_course)}
                                  </div>
                                </div>
                              </div>

                              <div className="row w-100">
                                <div className="col-md-12">
                                  <div className="gm-summary-checkbox-container mb-0">
                                    <span
                                      style={{
                                        marginRight: '12px',
                                        fontSize: '18px',
                                        color: formatBoolean(course?.is_take_class_at_college)
                                          ? '#1890ff'
                                          : '#d9d9d9',
                                        fontWeight: formatBoolean(course?.is_take_class_at_college)
                                          ? 'bold'
                                          : 'normal',
                                      }}
                                    >
                                      {formatBoolean(course?.is_take_class_at_college) ? '✓' : '○'}
                                    </span>
                                    I took this class at a college and/or I received college credit
                                    for this class
                                  </div>
                                </div>
                              </div>

                              {course?.is_take_class_at_college && (
                                <div className="row w-100">
                                  <div className="col-md-12">
                                    <div className="gm-summary-field-label">Select College *</div>
                                    <div className="gm-summary-field-value">
                                      {course?.college || '-'}
                                    </div>
                                  </div>
                                </div>
                              )}

                              {(course?.schedule === 'Semester' ||
                                course?.schedule === 'Trimester' ||
                                course?.schedule === 'Quarters') && (
                                <>
                                  <div className="row w-100">
                                    <div className="col-md-12">
                                      <GeneralSemesterOption item={course} index={index} />
                                    </div>
                                  </div>
                                </>
                              )}

                              {['Semester', 'Trimester', 'Quarters'].includes(course?.schedule) && (
                                <>
                                  <div className="row w-100">
                                    <div className="col-md-12">
                                      <div className="gm-summary-field-label">
                                        How are the grades for this class reported on your
                                        transcript?
                                      </div>
                                      <div className="gm-summary-field-value">
                                        {course?.schedule_transcript || '-'}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}

                              {(course?.grades ?? []).map((item: string, i: number) => {
                                if (course?.schedule_transcript === 'One final Grade') return null;
                                if (course?.schedule_transcript === 'Other') return null;
                                if (i === 0 && !course?.isFirstSemester) return null;
                                if (i === 1 && !course?.isSecondSemester) return null;
                                if (i === 2 && !course?.isThirdSemester) return null;
                                if (i === 3 && !course?.isFourthSemester) return null;
                                if (i < countGrades(course)) {
                                  return (
                                    <div className="row w-100">
                                      <div className="col-md-6 pe-md-2">
                                        <div className="gm-summary-field-label">Grade*</div>
                                        <div className="gm-summary-field-input">
                                          {course?.grades[i] || '-'}
                                        </div>
                                      </div>
                                      <div className="col-md-6 ps-md-2">
                                        <div className="gm-summary-field-label">Credits*</div>
                                        <div className="gm-summary-field-input">
                                          {course?.credits[i] || '-'}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                } else {
                                  return null;
                                }
                              })}

                              {course?.schedule_transcript !== 'One grade per term' && (
                                <div className="row w-100">
                                  <div className="col-md-6 pe-md-2">
                                    <div className="gm-summary-field-label">Final Grade*</div>
                                    <div className="gm-summary-field-input">
                                      {course?.final_grade || '-'}
                                    </div>
                                  </div>
                                  <div className="col-md-6 ps-md-2">
                                    <div className="gm-summary-field-label">Final Credits*</div>
                                    <div className="gm-summary-field-input">
                                      {course?.final_credit || '-'}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )
                    )}
                  </div>
                )}
              </>
            )}
          </div>

          {/* International School Experience Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">International School Experience</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Did you attend school outside the United States for any part of 6th through 8th
                  grade?
                  <span
                    className="gm-summary-field-logo span-uc-logo"
                    style={{ marginLeft: 0, marginRight: 0 }}
                  ></span>
                </div>
                <div className="gm-summary-field-value">
                  {formatBoolean(myGeneralInfo.is_attend_school_outside_us_6_through_8)
                    ? 'Yes'
                    : 'No'}
                </div>
              </div>
            </div>

            {formatBoolean(myGeneralInfo.is_attend_school_outside_us_6_through_8) === true && (
              <>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      What was the language of instruction? *
                    </div>
                    <div className="gm-summary-field-value">
                      {myGeneralInfo.language_instruction || '-'}
                    </div>
                  </div>
                </div>

                {myGeneralInfo.language_instruction === 'Other' && (
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">Specify the Language</div>
                      <div className="gm-summary-field-value">
                        {myGeneralInfo.specify_language_instruction || '-'}
                      </div>
                      <div className="gm-summary-field-count">
                        Text count:{' '}
                        {myGeneralInfo.specify_language_instruction?.split(/\s+/).filter(Boolean)
                          .length || 0}
                        /30 characters
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Did you complete high school/secondary school outside of the United States? *
                  <span className="gm-summary-field-logo span-csu-logo"></span>
                </div>
                <div className="gm-summary-field-value">
                  {formatBoolean(myGeneralInfo.additional_info?.completed_high_school_outside_US)
                    ? 'Yes'
                    : 'No'}
                </div>
              </div>
            </div>

            {formatBoolean(myGeneralInfo.is_attend_school_outside_us_6_through_8) === true && (
              <>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Academic Performance (High School GPA, Standing, Percentage, etc.)*
                    </div>
                    <div className="gm-summary-field-value">
                      {myGeneralInfo.additional_info?.high_school_academic_performance || '-'}
                    </div>
                    <div className="gm-summary-field-count">
                      Text count:{' '}
                      {myGeneralInfo.additional_info?.high_school_academic_performance
                        ?.split(/\s+/)
                        .filter(Boolean).length || 0}
                      /49 characters
                    </div>
                  </div>
                </div>

                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">
                      Name of Degree/Diploma (e.g. Diploma, A-Level, Abitur, Certificado)*
                    </div>
                    <div className="gm-summary-field-value">
                      {myGeneralInfo.additional_info?.degree_or_diploma_name || '-'}
                    </div>
                    <div className="gm-summary-field-count">
                      Text count:{' '}
                      {myGeneralInfo.additional_info?.degree_or_diploma_name
                        ?.split(/\s+/)
                        .filter(Boolean).length || 0}
                      /49 characters
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}

        </>
      )}
    </div>
  );
};

const Summary9th = ({ isMobile }: { isMobile: boolean }) => {
  const [myGradeAndCourse, setMyGradeAndCourse] = React.useState<any>(null);
  const [gradeData, setGradeData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.GRADE_9, reviewedAndComplete, setReviewedAndComplete);
  };
  const [show, setShow] = React.useState(false); // show model checkfield
  const handleCloseModalCheck = () => {
    setShow(false);
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await courseServices.getGradeAndCourse(params.id);
      setMyGradeAndCourse(res);
      let grade9th = checkEnableParseJSON(res?.grade_9_course_array, []);
      setGradeData(grade9th);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.GRADE_9
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          9th
        </Typography>
        <div></div>
      </div>

      {gradeData && Array.isArray(gradeData) && gradeData.length !== 0 && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">9th Grade Coursework</div>
          <CourseGrade9Summary data={gradeData} />
        </div>
      )}

      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Completion Confirmation</div>
        <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
          Please indicate that you have reported all courses and grades for 9th grade.*
        </div>
        <div className="gm-summary-checkbox-container">
          <span
            style={{
              marginRight: '12px',
              fontSize: '18px',
              color: formatBoolean(myGradeAndCourse?.is_reported_all_grade_9)
                ? '#1890ff'
                : '#d9d9d9',
              fontWeight: formatBoolean(myGradeAndCourse?.is_reported_all_grade_9)
                ? 'bold'
                : 'normal',
            }}
          >
            {formatBoolean(myGradeAndCourse?.is_reported_all_grade_9) ? '✓' : '○'}
          </span>
          I have reported all of my courses for this grade.
        </div>
      </div>

      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span
              style={{
                fontSize: isMobile ? '14px' : '12px',
                color: '#6c757d',
                fontWeight: '500',
              }}
            >
              Reviewed
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const Summary10th = ({ isMobile }: { isMobile: boolean }) => {
  const [myGradeAndCourse, setMyGradeAndCourse] = React.useState<any>(null);
  const [gradeData, setGradeData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.GRADE_10, reviewedAndComplete, setReviewedAndComplete);
  };
  const [show, setShow] = React.useState(false); // show model checkfield
  const handleCloseModalCheck = () => {
    setShow(false);
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await courseServices.getGradeAndCourse(params.id);
      setMyGradeAndCourse(res);
      let grade10th = tryParseJSON(res?.grade_10_course_array, []);
      setGradeData(grade10th);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.GRADE_10
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          10th
        </Typography>
      </div>

      {gradeData && Array.isArray(gradeData) && gradeData.length !== 0 && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">10th Grade Coursework</div>
          <CourseGrade9Summary data={gradeData} />
        </div>
      )}

      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Completion Confirmation</div>
        <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
          Please indicate that you have reported all courses and grades for 10th grade.*
        </div>
        <div className="gm-summary-checkbox-container">
          <span
            style={{
              marginRight: '12px',
              fontSize: '18px',
              color: formatBoolean(myGradeAndCourse?.is_reported_all_grade_10)
                ? '#1890ff'
                : '#d9d9d9',
              fontWeight: formatBoolean(myGradeAndCourse?.is_reported_all_grade_10)
                ? 'bold'
                : 'normal',
            }}
          >
            {formatBoolean(myGradeAndCourse?.is_reported_all_grade_10) ? '✓' : '○'}
          </span>
          I have reported all of my courses for this grade.
        </div>
      </div>

      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span
              style={{
                fontSize: isMobile ? '14px' : '12px',
                color: '#6c757d',
                fontWeight: '500',
              }}
            >
              Reviewed
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const Summary11th = ({ isMobile }: { isMobile: boolean }) => {
  const [myGradeAndCourse, setMyGradeAndCourse] = React.useState<any>(null);
  const [gradeData, setGradeData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.GRADE_11, reviewedAndComplete, setReviewedAndComplete);
  };
  const [show, setShow] = React.useState(false); // show model checkfield
  const handleCloseModalCheck = () => {
    setShow(false);
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await courseServices.getGradeAndCourse(params.id);
      setMyGradeAndCourse(res);
      let grade11th = checkEnableParseJSON(res?.grade_11_course_array, []);
      setGradeData(grade11th);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.GRADE_11
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          11th
        </Typography>
        <div>
        </div>
      </div>

      {gradeData && Array.isArray(gradeData) && gradeData.length !== 0 && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">11th Grade Coursework</div>
          <CourseGrade9Summary data={gradeData} />
        </div>
      )}

      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Completion Confirmation</div>
        <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
          Please indicate that you have reported all courses and grades for 11th grade.*
        </div>
        <div className="gm-summary-checkbox-container">
          <span
            style={{
              marginRight: '12px',
              fontSize: '18px',
              color: formatBoolean(myGradeAndCourse?.is_reported_all_grade_11)
                ? '#1890ff'
                : '#d9d9d9',
              fontWeight: formatBoolean(myGradeAndCourse?.is_reported_all_grade_11)
                ? 'bold'
                : 'normal',
            }}
          >
            {formatBoolean(myGradeAndCourse?.is_reported_all_grade_11) ? '✓' : '○'}
          </span>
          I have reported all of my courses for this grade.
        </div>
      </div>
      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span
              style={{
                fontSize: isMobile ? '14px' : '12px',
                color: '#6c757d',
                fontWeight: '500',
              }}
            >
              Reviewed
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const Summary12th = ({ isMobile }: { isMobile: boolean }) => {
  const [myGradeAndCourse, setMyGradeAndCourse] = React.useState<any>(null);
  const [gradeData, setGradeData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [show, setShow] = React.useState(false); // show model checkfield
  const handleCloseModalCheck = () => {
    setShow(false);
  };
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.GRADE_12, reviewedAndComplete, setReviewedAndComplete);
  };
  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await courseServices.getGradeAndCourse(params.id);
      console.log('getGradeAndCourse data: ', res);
      setMyGradeAndCourse(res);
      let grade12th = checkEnableParseJSON(res?.grade_12_course_array, []);
      setGradeData(grade12th);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.GRADE_12
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  let course_array = checkEnableParseJSON(myGradeAndCourse?.course_array, [])?.map((i: any) => {
    return {
      ...i,
      schedule: [`${i.schedule ?? ''}`].join(', '),
    };
  });
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          12th
        </Typography>
        <div>
        </div>
      </div>

      <div className="gm-summary-section">
        <div className="gm-summary-section-title">12th Grade Coursework</div>
        <CourseGrade12Summary
          data={myGradeAndCourse}
        />
      </div>

      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Completion Confirmation</div>
        <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
          Please indicate that you have reported all courses and grades for 12th grade.*
        </div>
        <div className="gm-summary-checkbox-container">
          <span
            style={{
              marginRight: '12px',
              fontSize: '18px',
              color: formatBoolean(myGradeAndCourse?.is_reported_all_grade_12)
                ? '#1890ff'
                : '#d9d9d9',
              fontWeight: formatBoolean(myGradeAndCourse?.is_reported_all_grade_12)
                ? 'bold'
                : 'normal',
            }}
          >
            {formatBoolean(myGradeAndCourse?.is_reported_all_grade_12) ? '✓' : '○'}
          </span>
          I have reported all of my courses for this grade.
        </div>
      </div>

      {checkEnableParseJSON(myGradeAndCourse?.course_title, {})?.is_indicated_all_course && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">Additional Course Confirmation</div>
          <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
            Have you indicated all your middle school, post-12th grade, or summer courses?
          </div>
          <div className="gm-summary-checkbox-container">
            {/* <div className="gm-summary-text-primary">
              I have reported all of my courses for this grade.
            </div> */}
            <span
              style={{
                marginRight: '12px',
                fontSize: '18px',
                color: formatBoolean(
                  checkEnableParseJSON(myGradeAndCourse?.course_title, {})?.is_indicated_all_course
                )
                  ? '#1890ff'
                  : '#d9d9d9',
                fontWeight: formatBoolean(
                  checkEnableParseJSON(myGradeAndCourse?.course_title, {})?.is_indicated_all_course
                )
                  ? 'bold'
                  : 'normal',
              }}
            >
              {formatBoolean(
                checkEnableParseJSON(myGradeAndCourse?.course_title, {})?.is_indicated_all_course
              )
                ? '✓'
                : '○'}
            </span>
            I have reported all of my courses for this grade.
          </div>
        </div>
      )}

      {myGradeAndCourse && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">Current or Most Recent Year Courses</div>
          <div className="gm-summary-conditional-section">
            <div className="gm-summary-conditional-title">Coursework</div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Please select the main course scheduling system your institution is using.**
                </div>
                <div className="gm-summary-field-value">
                  {myGradeAndCourse?.course_scheduling_system_is_using || '-'}
                </div>
              </div>
            </div>

            <div className="gm-summary-checkbox-container">
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(myGradeAndCourse?.is_fields_enter_your_current_year_course)
                    ? '#1890ff'
                    : '#d9d9d9',
                  fontWeight: formatBoolean(
                    myGradeAndCourse?.is_fields_enter_your_current_year_course
                  )
                    ? 'bold'
                    : 'normal',
                }}
              >
                {formatBoolean(myGradeAndCourse?.is_fields_enter_your_current_year_course)
                  ? '✓'
                  : '○'}
              </span>
              My 12th grade courses are my current courses
            </div>

            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              Please list all courses you are taking this academic year. If you are not currently
              enrolled, please list courses from your most recent academic year.
            </div>

            <SimpleTable
              data={course_array}
              column={[
                {
                  label: 'Please select the course scheduling system your school is using',
                  value: 'course_scheduling_system_is_using',
                },
                { label: 'Course title', value: 'title' },
                { label: 'Subject', value: 'subject' },
                { label: 'Course Level', value: 'level' },
                { label: 'Course Schedule', value: 'schedule' },
              ]}
            />
          </div>
        </div>
      )}

      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input type="checkbox" checked={reviewedAndComplete} onClick={onReviewdAndComplete} />
            <span
              style={{
                fontSize: isMobile ? '14px' : '12px',
                color: '#6c757d',
                fontWeight: '500',
              }}
            >
              Reviewed
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const SummaryCollegeCourses = ({ isMobile }: { isMobile: boolean }) => {
  const [myGradeAndCourse, setMyGradeAndCourse] = React.useState<any>(null);
  const [collegeCoureData, setCollegeCoureData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.COLLEGE_COURSE, reviewedAndComplete, setReviewedAndComplete);
  };
  const [show, setShow] = React.useState(false); // show model checkfield
  const handleCloseModalCheck = () => {
    setShow(false);
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await courseServices.getGradeAndCourse(params.id);
      setMyGradeAndCourse(res);
      let arr: any[] = tryParseJSON(res?.college_course_array) ?? [];
      setCollegeCoureData(arr);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.COLLEGE_COURSE
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          College Courses
        </Typography>
        <div>
        </div>
      </div>

      {collegeCoureData && Array.isArray(collegeCoureData) && collegeCoureData.length !== 0 && (
        <div className="gm-summary-section">
          <div className="gm-summary-section-title">College Coursework</div>
          <CourseCollegeSum data={collegeCoureData} />
        </div>
      )}

      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Completion Confirmation</div>
        <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
          Please indicate that you added all of the courses you have taken or plan to take for every
          college OR if you have no college courses to report.
        </div>
        <div className="gm-summary-checkbox-container">
          <span
            style={{
              marginRight: '12px',
              fontSize: '18px',
              color: formatBoolean(myGradeAndCourse?.is_finish_adding_all_college_grade)
                ? '#1890ff'
                : '#d9d9d9',
              fontWeight: formatBoolean(myGradeAndCourse?.is_finish_adding_all_college_grade)
                ? 'bold'
                : 'normal',
            }}
          >
            {formatBoolean(myGradeAndCourse?.is_finish_adding_all_college_grade) ? '✓' : '○'}
          </span>
          I'm finished adding all the college grade classes I've taken or plan to take for every
          college I've attended OR I have no college courses to report.
        </div>
      </div>

      {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}
    </div>
  );
};

const AGSummary = () => {
  const [myAGSummary, setMyAGSummary] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();

  const conditionGradeTH = (item: any, schedule: any, gradeScale: any) => {
    if (!item) return 0;

    const finalGrade = item.finalGrade;
    const finalCredit = item.finalCredits;

    if (schedule === 'Yearly' || schedule === 'Other') {
      if (gradeScale === 'A-F') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditAwarded(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      } else if (isPercentNumericScale(gradeScale)) {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditEligible(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      }
    } else {
      //semester, quarter, trimester
      const scheduleTranscript = item.schedule_transcript;
      const grades = item.grade ?? []; //Gán mặc định là mảng rỗng để tránh lỗi nếu grades không tồn tại
      const credits = item.credits ?? [];

      if (gradeScale === 'A-F') {
        if (item.isFirstSemester === true && item.isSecondSemester === true) {
          return selectTwoSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemester(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemester(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      } else if (isPercentNumericScale(gradeScale)) {
        if (item.isFirstSemester === true && item.isSecondSemester === true) {
          return selectTwoSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemesterEligible(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemesterEligible(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      }
    }
    return 0;
  };

  const selectOneSemester = (
    gradeIndex: number,
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      if (
        !checkEmptyValue(grades[gradeIndex]) &&
        !checkEmptyValue(credits[gradeIndex]) &&
        !checkNoCreditAwarded(grades[gradeIndex])
      ) {
        point += getPointYearFromSchedule(schedule);
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectOneSemesterEligible = (
    gradeIndex: number,
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      if (
        !checkEmptyValue(grades[gradeIndex]) &&
        !checkEmptyValue(credits[gradeIndex]) &&
        !checkNoCreditEligible(grades[gradeIndex])
      ) {
        point += getPointYearFromSchedule(schedule);
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const conditionCollegeCourses = (item: any, scheduleSystem: string) => {
    if (
      !item ||
      item?.honorStatus !== 'CL' ||
      item?.transferable !== true ||
      item?.completionStatus === 'Select' ||
      checkEmptyValue(item?.grade) ||
      checkNoCreditGradeCollege(item?.grade)
    ) {
      return 0;
    }
    //Old logic : tính điểm của College course mà kg phải Dual Enrollment là phụ thuộc vào field Schedule System trên page College Course (O.5 hoặc 0.3)
    // const pointYear = getPointYearFromSchedule(scheduleSystem);
    //New logic : College course luôn luôn tính là 1 nếu Type of Class khác Dual Enrollment
    const pointYear = 1;
    return pointYear;
  };

  //For Grade Scale A-F
  const selectTwoSemester = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 2; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditAwarded(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  //For Grade Scale 1-100
  const selectTwoSemesterEligible = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 2; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditEligible(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectThreeSemester = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 3; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditAwarded(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      if (checkThreeTrimester(point) === true) {
        point = 1; // Tránh trường hợp điểm bị làm tròn xuống 0.999
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };
  const selectThreeSemesterEligible = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 3; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditEligible(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      if (checkThreeTrimester(point) === true) {
        point = 1; // Tránh trường hợp điểm bị làm tròn xuống 0.999
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectFourSemester = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 4; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditAwarded(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectFourSemesterEligible = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 4; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditEligible(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const conditionGeneralInfo = (item: any) => {
    if (
      !item ||
      checkEmptyValue(item?.type_of_class) ||
      checkEmptyValue(item?.is_weighted_course)
    ) {
      return 0;
    }

    const schedule = item.schedule; // Lưu giá trị schedule để dùng lại
    const finalGrade = item.final_grade;
    const finalCredit = item.final_credit;
    const gradeScale = item.grade_scale;

    if (schedule === 'Yearly' || schedule === 'Other') {
      if (gradeScale === 'A-F') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditAwarded(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      } else if (isPercentNumericScale(gradeScale)) {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditEligible(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      }
    } else {
      //semester, quarter, trimester
      const scheduleTranscript = item.schedule_transcript;
      const grades = item.grades ?? []; //Gán mặc định là mảng rỗng để tránh lỗi nếu grades không tồn tại
      const credits = item.credits ?? [];

      if (gradeScale === 'A-F') {
        if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === false &&
          item.isFourthSemester === false
        ) {
          return selectTwoSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === true &&
          item.isFourthSemester === false
        ) {
          return selectThreeSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === true &&
          item.isFourthSemester === true
        ) {
          return selectFourSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemester(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemester(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      } else if (isPercentNumericScale(gradeScale)) {
        if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === false &&
          item.isFourthSemester === false
        ) {
          return selectTwoSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === true &&
          item.isFourthSemester === false
        ) {
          return selectThreeSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          item.isFirstSemester === true &&
          item.isSecondSemester === true &&
          item.isThirdSemester === true &&
          item.isFourthSemester === true
        ) {
          return selectFourSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemesterEligible(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemesterEligible(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      }
    }
    return 0;
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await caculatorSubjectYears(params.id);
      setMyAGSummary(res);
      setLoading(false);
    };
    const caculatorSubjectYears = async (studentId: any) => {
      let countKeys = {
        A: 0,
        B: 0,
        C: 0,
        D1: 0,
        D2: 0,
        E: 0,
        F: 0,
        G: 0,
      };
      const resGradeAndCourse: any = await courseServices.getGradeAndCourse(studentId);
      const resGeneral: any = await courseServices.getGeneral(studentId);

      const summary9th = checkEnableParseJSON(resGradeAndCourse?.grade_9_course_array, []);
      const summary10th = checkEnableParseJSON(resGradeAndCourse?.grade_10_course_array, []);
      const summary11th = checkEnableParseJSON(resGradeAndCourse?.grade_11_course_array, []);
      const summary12th = checkEnableParseJSON(resGradeAndCourse?.grade_12_course_array, []);

      const summaryTH = [...summary9th, ...summary10th, ...summary11th, ...summary12th];
      const summaryCollegeCourses = checkEnableParseJSON(
        resGradeAndCourse?.college_course_array,
        []
      );
      const additional_info = checkEnableParseJSON(resGeneral?.additional_info, {});
      let listCollegeCourses: string[] = [];

      if (summaryTH && summaryTH.length > 0) {
        (summaryTH ?? []).forEach((item: any) => {
          mapAGSumaryCalculation(item);
          item?.subjectDetails?.forEach((subject: any) => {
            if (
              checkTypeOfClassDualEnrollment(
                subject?.typeOfClass,
                subject?.isTakeClassAtCollege
              ) === true
            ) {
              listCollegeCourses.push(subject?.collegeTookClass);
            }
            const pointYear = conditionGradeTH(subject, item?.schedule, item?.CMGradingScale);
            if (!checkEmptyValue(pointYear)) {
              let agSubjectArea = subject?.AGSubjectArea;
              const firstLetter = paserSubjectFirst(agSubjectArea).startLetter;
              if (firstLetter && firstLetter in countKeys) {
                let currentValue = (countKeys as any)[firstLetter];
                (countKeys as any)[firstLetter] = currentValue + pointYear;
              }
            }
          });
        });
      }

      if (summaryCollegeCourses && summaryCollegeCourses.length > 0) {
        (summaryCollegeCourses ?? []).forEach((item: any) => {
          const collegeName = item?.collegeName ?? '';
          const isExist: any[] =
            listCollegeCourses && listCollegeCourses.length > 0
              ? listCollegeCourses.filter((name: string) => name && name.includes(collegeName))
              : []; // Kiểm tra collegeName đã có trong listCollegeCourses chưa

          if (isExist.length === 0) {
            item?.collegeCourseArray?.forEach((subject: any) => {
              const scheduleSystem = item?.scheduleSystem ?? '';
              const pointYear = conditionCollegeCourses(subject, scheduleSystem);
              if (!checkEmptyValue(pointYear)) {
                const subjectAreaValue = subject?.subject;
                const keyMap = checkSubjectMap(subjectAreaValue);
                if (keyMap != null) {
                  let currentValue = (countKeys as any)[keyMap];
                  (countKeys as any)[keyMap] = currentValue + pointYear;
                }
              }
            });
          }
        });
      }

      if (
        additional_info &&
        additional_info.course_work &&
        additional_info.course_work.length > 0
      ) {
        (additional_info?.course_work ?? []).forEach((item: any) => {
          const pointYear = conditionGeneralInfo(item);
          if (!checkEmptyValue(pointYear)) {
            const agSubjectArea = item?.ag_subject_requirement;
            const firstLetter = paserSubjectFirst(agSubjectArea).startLetter;
            if (firstLetter && firstLetter in countKeys) {
              let currentValue = (countKeys as any)[firstLetter];
              (countKeys as any)[firstLetter] = currentValue + pointYear;
            }
          }
        });
      }

      return countKeys;
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">A-G Subject Summary</div>
        <div className="gm-summary-field-grid">
          {Object.entries(agSubjectTotals).map(([key, value]) => (
            <div key={key} className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                <span className={'subject ' + key}>{key}</span>
                <span className="subject-text"> {value}</span>
              </div>
              <div className="gm-summary-field-value">{myAGSummary?.[key] || '0'}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const WCourseSummary = () => {
  const [myAGSummary, setMyAGSummary] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [totalCredits, setTotalCredits] = React.useState(0);

  const conditionGradeTH = (item: any, schedule: any, gradeScale: any) => {
    if (!item) return 0;

    const finalGrade = item.finalGrade;
    const finalCredit = item.finalCredits;

    if (schedule === 'Yearly' || schedule === 'Other') {
      if (gradeScale === 'A-F') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditAwarded(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      } else if (isPercentNumericScale(gradeScale)) {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditEligible(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      }
    } else {
      //semester, quarter, trimester
      const scheduleTranscript = item.schedule_transcript;
      const grades = item.grade ?? []; //Gán mặc định là mảng rỗng để tránh lỗi nếu grades không tồn tại
      const credits = item.credits ?? [];

      if (gradeScale === 'A-F') {
        if (
          isSemesterOn(item.isFirstSemester) === true &&
          isSemesterOn(item.isSecondSemester) === true
        ) {
          return selectTwoSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          isSemesterOn(item.isFirstSemester) === true &&
          isSemesterOn(item.isSecondSemester) === false
        ) {
          return selectOneSemester(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          isSemesterOn(item.isFirstSemester) === false &&
          isSemesterOn(item.isSecondSemester) === true
        ) {
          return selectOneSemester(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      } else if (isPercentNumericScale(gradeScale)) {
        if (
          isSemesterOn(item.isFirstSemester) === true &&
          isSemesterOn(item.isSecondSemester) === true
        ) {
          return selectTwoSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          isSemesterOn(item.isFirstSemester) === true &&
          isSemesterOn(item.isSecondSemester) === false
        ) {
          return selectOneSemesterEligible(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          isSemesterOn(item.isFirstSemester) === false &&
          isSemesterOn(item.isSecondSemester) === true
        ) {
          return selectOneSemesterEligible(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      }
    }
    return 0;
  };

  const selectOneSemester = (
    gradeIndex: number,
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      if (
        !checkEmptyValue(grades[gradeIndex]) &&
        !checkEmptyValue(credits[gradeIndex]) &&
        !checkNoCreditAwarded(grades[gradeIndex])
      ) {
        point += getPointYearFromSchedule(schedule);
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectOneSemesterEligible = (
    gradeIndex: number,
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      if (
        !checkEmptyValue(grades[gradeIndex]) &&
        !checkEmptyValue(credits[gradeIndex]) &&
        !checkNoCreditEligible(grades[gradeIndex])
      ) {
        point += getPointYearFromSchedule(schedule);
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const conditionCollegeCourses = (item: any, scheduleSystem: string) => {
    if (
      !item ||
      item?.honorStatus !== 'CL' ||
      item?.transferable !== true ||
      item?.completionStatus === 'Select' ||
      checkEmptyValue(item?.grade) ||
      checkNoCreditGradeCollege(item?.grade)
    ) {
      return 0;
    }

    //Change logic make it so that every transferable college course is equal to 1.0 credits
    const pointYear = getPointYearFromSchedule('Yearly');
    return pointYear;
  };

  //For Grade Scale A-F
  const selectTwoSemester = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 2; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditAwarded(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  //For Grade Scale 1-100
  const selectTwoSemesterEligible = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 2; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditEligible(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const conditionGeneralInfo = (item: any) => {
    if (
      !item ||
      checkEmptyValue(item?.type_of_class) ||
      checkEmptyValue(item?.is_weighted_course)
    ) {
      return 0;
    }

    const schedule = item.schedule; // Lưu giá trị schedule để dùng lại
    const finalGrade = item.final_grade;
    const finalCredit = item.final_credit;
    const gradeScale = item.grade_scale;

    if (schedule === 'Yearly' || schedule === 'Other') {
      if (gradeScale === 'A-F') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditAwarded(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      } else if (isPercentNumericScale(gradeScale)) {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditEligible(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      }
    } else {
      //semester, quarter, trimester
      const scheduleTranscript = item.schedule_transcript;
      const grades = item.grades ?? []; //Gán mặc định là mảng rỗng để tránh lỗi nếu grades không tồn tại
      const credits = item.credits ?? [];

      if (gradeScale === 'A-F') {
        if (item.isFirstSemester === true && item.isSecondSemester === true) {
          return selectTwoSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemester(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemester(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      } else if (isPercentNumericScale(gradeScale)) {
        if (item.isFirstSemester === true && item.isSecondSemester === true) {
          return selectTwoSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemesterEligible(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemesterEligible(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      }
    }
    return 0;
  };

  const getPointWeightedCourse = (item: any, typeOfClass: any) => {
    const isHonors = checkTypeOfClass(typeOfClass, 'Honors');
    if (isHonors === true) {
      let weightedPoint = getPointYearFromSchedule(item?.schedule);
      return weightedPoint;
    }
    return 0;
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await caculatorSubjectYears(params.id);
      setMyAGSummary(res);
      setLoading(false);
    };
    const caculatorSubjectYears = async (studentId: any) => {
      let countKeys = {
        WH: 0,
        AP: 0,
        IB: 0,
        TC: 0,
      };
      const resGradeAndCourse: any = await courseServices.getGradeAndCourse(studentId);
      const resGeneral: any = await courseServices.getGeneral(studentId);

      const summary9th = checkEnableParseJSON(resGradeAndCourse?.grade_9_course_array, []);
      const summary10th = checkEnableParseJSON(resGradeAndCourse?.grade_10_course_array, []);
      const summary11th = checkEnableParseJSON(resGradeAndCourse?.grade_11_course_array, []);
      const summary12th = checkEnableParseJSON(resGradeAndCourse?.grade_12_course_array, []);

      const summaryTH = [...summary9th, ...summary10th, ...summary11th, ...summary12th];
      const summaryCollegeCourses = checkEnableParseJSON(
        resGradeAndCourse?.college_course_array,
        []
      );
      const additional_info = checkEnableParseJSON(resGeneral?.additional_info, {});

      (summaryTH ?? []).forEach((item: any) => {
        item?.subjectDetails?.forEach((obj: any) => {
          let subject: any = Object.assign({}, obj);
          mapAGSumary_Value(subject);
          const pointYear = conditionGradeTH(subject, item?.schedule, item?.CMGradingScale);
          const typeOfClass = subject?.typeOfClass;
          const isWeightedCourse = subject?.isWeightedCourse;
          if (!checkEmptyValue(pointYear)) {
            //pointYear != 0
            //Type of Class
            const firstLetter = getKeyTypeOfCourse(typeOfClass, wCourseSummary);
            if (firstLetter != null) {
              let currentValue = (countKeys as any)[firstLetter];
              if (checkWeightedCourse(isWeightedCourse)) {
                (countKeys as any)[firstLetter] = currentValue + pointYear;
              }
            }

            //Weighted Course
            if (checkWeightedCourse(isWeightedCourse)) {
              const keyWeighted = getKeyTypeOfCourse('Weighted Honors Courses', wCourseSummary);
              if (keyWeighted != null) {
                const keyWeightedValue = (countKeys as any)[keyWeighted];
                const isHonors = checkTypeOfClass(typeOfClass, 'Honors');
                if (isHonors === true) {
                  (countKeys as any)[keyWeighted] = keyWeightedValue + pointYear;
                }
              }
            }
          } else {
            //pointYear == 0
            if (checkWeightedCourse(isWeightedCourse)) {
              const keyWeighted = getKeyTypeOfCourse('Weighted Honors Courses', wCourseSummary);
              if (keyWeighted != null) {
                const keyWeightedValue = (countKeys as any)[keyWeighted];
                // (countKeys as any)[keyWeighted] = keyWeightedValue + getPointWeightedCourse(item, typeOfClass);
              }
            }
          }
        });
      });

      (summaryCollegeCourses ?? []).forEach((item: any) => {
        item?.collegeCourseArray?.forEach((subject: any) => {
          const scheduleSystem = item?.scheduleSystem;
          const pointYear = conditionCollegeCourses(subject, scheduleSystem);
          if (!checkEmptyValue(pointYear)) {
            const transferable = subject?.transferable;
            if (transferable === true) {
              const keyWeighted = getKeyTypeOfCourse(
                'Transferable College Courses',
                wCourseSummary
              );
              if (keyWeighted != null) {
                const keyWeightedValue = (countKeys as any)[keyWeighted];
                (countKeys as any)[keyWeighted] = keyWeightedValue + pointYear;
              }
            }
          }
        });
      });

      (additional_info?.course_work ?? []).forEach((item: any) => {
        const pointYear = conditionGeneralInfo(item);
        const typeOfClass = item.type_of_class;
        const isWeightedCourse = item.is_weighted_course;
        if (!checkEmptyValue(pointYear)) {
          //pointYear != 0
          //Type of Class
          const firstLetter = getKeyTypeOfCourse(typeOfClass, wCourseSummary);
          if (firstLetter != null) {
            let currentValue = (countKeys as any)[firstLetter];
            if (typeOfClass === 'Regular' && !checkWeightedCourse(isWeightedCourse)) {
              (countKeys as any)[firstLetter] = currentValue + pointYear;
            } else {
              if (checkWeightedCourse(isWeightedCourse)) {
                (countKeys as any)[firstLetter] = currentValue + pointYear;
              }
            }
          }
          //Weighted Course
          if (checkWeightedCourse(isWeightedCourse)) {
            //weighted course = Yes
            const keyWeighted = getKeyTypeOfCourse('Weighted Honors Courses', wCourseSummary);
            if (keyWeighted != null) {
              const keyWeightedValue = (countKeys as any)[keyWeighted];
              const isHonors = checkTypeOfClass(typeOfClass, 'Honors');
              if (isHonors === true) {
                (countKeys as any)[keyWeighted] = keyWeightedValue + pointYear;
              }
            }
          }
        } else {
          //pointYear == 0
          if (checkWeightedCourse(isWeightedCourse)) {
            const keyWeighted = getKeyTypeOfCourse('Weighted Honors Courses', wCourseSummary);
            if (keyWeighted != null) {
              const keyWeightedValue = (countKeys as any)[keyWeighted];
              // (countKeys as any)[keyWeighted] = keyWeightedValue + getPointWeightedCourse(item, typeOfClass);
            }
          }
        }
      });

      //Total Points
      const total = Object.values(countKeys).reduce((a, b) => a + b, 0);
      setTotalCredits(total);
      return countKeys;
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">(W) Course Summary</div>
        <div className="gm-summary-field-grid">
          {Object.entries(wCourseSummary).map(([key, value]) => (
            <div key={key} className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                <span className="subject-text">{value as any}</span>
              </div>
              <div className="gm-summary-field-value">{myAGSummary?.[key] || '0'}</div>
            </div>
          ))}
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              <span className="subject-text">Total:</span>
            </div>
            <div className="gm-summary-field-value">{totalCredits}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
